export let NotificationType = /*#__PURE__*/function (NotificationType) {
  NotificationType["DEFAULT"] = "default";
  NotificationType["ERROR"] = "error";
  NotificationType["SUCCESS"] = "success";
  NotificationType["WARNING"] = "warning";
  return NotificationType;
}({});